import {
  LeaderboardClock,
  LeaderboardPrefix,
  LeaderboardTillAge,
  LeaderboardType,
} from '@features/landing/grandprix/typings';

export type LeaderboardParams = {
  clock: LeaderboardClock;
  leaderboardType: LeaderboardType;
  tillAge: LeaderboardTillAge;
};

export function getLeaderboardId({
  clock,
  leaderboardType,
  tillAge,
}: LeaderboardParams) {
  const prefix: LeaderboardPrefix = 'school';
  return `${prefix}-grand-prix-${clock}-${leaderboardType}-till-${tillAge}`;
}
